import 'babel-polyfill';
import createFocusTrap from 'focus-trap/index.js';
import { PinClickEvent, PinHoverEvent, CardHoverEvent, CardClickEvent } from './Events.js';
import { OptimizedResizeInstance } from 'js/components/Util/OptimizedResize.js';
import { Maps } from 'js/components/Maps/index.js';
import { SearchMap } from 'js/search/modules/Google.js';
import { Header } from 'js/common/modules/Header.js';
import { activeBranchSvg, activePaypointSvg, branchSvg, hoverBranchSvg, hoverPaypointSvg, paypointSvg } from 'js/common/helper.js';

export class CobaltMap extends SearchMap {
  static initClass() {
    Maps.FactoryForProvider.Google = (data) => new this(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.CobaltMap";
    this.breakPoint = 992;
  }

  constructor(args) {
    super(args);
    this.pinHeight = 50;
    this.pinWidth = 39;
    this.largePinHeight = 50;
    this.largePinWidth = 39;
    this.pins = [];
  }

  calcOffset() {
    return 10;
  }

  iconImage(loc, i, isActive, isHovered = false) {
    const isPayPoint = loc && loc.customByName && loc.customByName['PayPoint Pages'] ? true : false;
    let iconUrl = `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPin(isPayPoint, isActive, isHovered))}`;

    if(isActive){
      return {
        url: iconUrl,
        scaledSize: new google.maps.Size(this.largePinWidth,this.largePinHeight)
      };
    } else {
      return {
        url: iconUrl,
        scaledSize: new google.maps.Size(this.pinWidth,this.pinHeight)
      };
    }
  }


  svgPin(isPayPoint, isActive, isHovered) {
    if (isPayPoint)
      if (isActive)
        return activePaypointSvg;
      else if (isHovered)
        return hoverPaypointSvg;
      else
        return paypointSvg;
    if (isActive)
      return activeBranchSvg;
    else if (isHovered)
      return hoverBranchSvg;
    return branchSvg;
  }

  scrollToLoc(loc) {
    const searchBoxHeight = $('.Locator-searchWrapper').innerHeight() + 10;
    const scrollHeight = $('.Locator-content').scrollTop() + $(`#js-yl-${loc.id}`).position().top - searchBoxHeight;

    const scrollToCard = function() {
      $('.Locator-content').animate({scrollTop: scrollHeight}, 500);
    };

    const scrollOffset = window.pageYOffset || document.documentElement.scrollTop;
    const locator = document.querySelector('#js-locator');
    const locatorDistance = locator.getBoundingClientRect().top + scrollOffset;

    $('html, body').animate({
      scrollTop: locatorDistance,
    }, 400, scrollToCard);
  }


  registerResultHandlers() {
    registerResultHandlers();
  }

  removePins() {
    for (let pin of this.pins) {
      pin.setMap(null);
    }
    this.pins = [];
  }

  updateMap() {
    this.boundsForPins = new google.maps.LatLngBounds();
    this.infowindow = new google.maps.InfoWindow();

    this.pins = [];
    let idx = 0;

    for (let location of Array.from(this.allLocations)) {
      let pin = this.preparePin(idx, location, this.map);
      this.boundsForPins.extend(pin.position);
      this.pins.push(pin);
      idx++;
    }
    this.redrawMap();
  }

  prepareMap() {
    const map = super.prepareMap();
    this.constructor.map = map;
    return map;
  }

  stylePin(pin) {
    let icon = this.iconImage(loc, i, false);

    if (pin.isSelected) {
      icon = this.iconImage(loc, i, true);
      pin.setZIndex(1);
    } else if (pin.isHovered) {
      icon = this.iconImage(loc, i, false);
      pin.setZIndex(1);
    } else {
      pin.setZIndex(0);
    }
    this.validatePinIcon(icon);
    pin.setIcon(icon);
  }

  preparePin(i, loc, m) {
    let icon = this.iconImage(loc, i, false);

    this.validatePinIcon(icon);
    const position = new google.maps.LatLng(loc.latitude, loc.longitude);
    const markerTitle = this.markerTitle(loc, i);
    let pin = new google.maps.Marker({
      position: position,
      icon,
      map: m,
      title: markerTitle,
      ariaLabel: markerTitle,
      zIndex: 65,
      optimized: false // For IE <= 11 compat
    });
    pin.setTitle(markerTitle);


    pin.addListener('click', () => {
      this.clickHandler(loc, pin, i, m);
    });

    this.pins.push(pin);
    pin.isHovered = false;
    pin.isSelected = false;

    pin.addListener('mouseover', () => {
      this.hoverHandler(true, loc, pin, i, m);
    });
    pin.addListener('mouseout', () => {
      this.hoverHandler(false, loc, pin, i, m);
    })

    document.addEventListener(CardClickEvent.eventTypeName, (event) => {
      let myTarget = `js-yl-${loc.id}`;
      if (event.detail.yextId == myTarget) {
        const bounds = m.getBounds();
        if (!bounds.contains(position)) {
          m.panTo(position);
        }

        let activeIcon = this.iconImage(loc, i, true);
        pin.setIcon(activeIcon);
        pin.isSelected = true;
      } else {
        let icon = this.iconImage(loc, i, this.defaultColor, this.defaultText);
        this.validatePinIcon(icon);
        pin.setIcon(icon);
        pin.isSelected = false;
        pin.isHovered = false;
      }
    });

    document.addEventListener(PinClickEvent.eventTypeName, (event) => {
      let myTarget = `js-yl-${loc.id}`;
      if (event.detail.yextId == myTarget) {
        this.scrollToLoc(loc);
        let activeIcon = this.iconImage(loc, i, true);
        pin.setIcon(activeIcon);
        pin.isSelected = true;
      } else {
        let icon = this.iconImage(loc, i, this.defaultColor, this.defaultText);
        this.validatePinIcon(icon);
        pin.setIcon(icon);
        pin.isSelected = false;
        pin.isHovered = false;
      }
    });

    document.addEventListener(CardHoverEvent.eventTypeName, (event) => {
      let myTarget = `js-yl-${loc.id}`;
      if (pin.isSelected) {
        pin.isHovered = event.detail.active;
        return;
      }

      if (event.detail.yextId == myTarget && event.detail.active) {
        let icon = this.iconImage(loc, i, false, true);
        this.validatePinIcon(icon);
        pin.setIcon(icon);
        pin.isHovered = true;
      } else {
        let icon = this.iconImage(loc, i, false, false);
        this.validatePinIcon(icon);
        pin.setIcon(icon);
        pin.isHovered = false;
      }
    });

    document.addEventListener(PinHoverEvent.eventTypeName, (event) => {
      let myTarget = `js-yl-${loc.id}`;
      if (pin.isSelected) {
        pin.isHovered = event.detail.active;
        return;
      }
      if (event.detail.yextId == myTarget && event.detail.active) {
        let icon = this.iconImage(loc, i, false, true);
        this.validatePinIcon(icon);
        pin.setIcon(icon);
        pin.isHovered = true;
      } else {
        let icon = this.iconImage(loc, i, false, false);
        this.validatePinIcon(icon);
        pin.setIcon(icon);
        pin.isHovered = false;
      }
    });
    return pin;
  }
}
CobaltMap.initClass();

const registerResultHandlers = () => {
  let results = document.getElementsByClassName('js-location-result');

  if(Array.from(results).length > 0){
    try {
      s.pageName="nbw:support:contact us:branch finder:locator:search results";
      s.t();
    } catch (err){
      console.log(err);
    }
  }

  for (let result of Array.from(results)) {
    result.addEventListener('click', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardClickEvent(this.getAttribute('id')));
    });
    result.addEventListener('mouseover', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardHoverEvent(this.getAttribute('id'), true));
    });
    result.addEventListener('mouseout', function() {
      const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
      if (!minWidthSearchMapBreakPointQuery.matches) { return; }
      document.dispatchEvent(new CardHoverEvent(this.getAttribute('id'), false));
    });
  }
}

const registerDocumentHandlers = () => {
  document.addEventListener(PinClickEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    if (id == null) { return; }
    const minWidthSearchMapBreakPointQuery = window.matchMedia(`(min-width: ${Yext.Maps.CobaltMap.breakPoint}px)`);
    if (minWidthSearchMapBreakPointQuery.matches) {
      document.getElementById(id).classList.add('is-selected');
    }
    let toRemove = document.querySelectorAll(`.js-location-result.is-selected:not(#${id})`);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-selected');
      toChange.classList.remove('is-hovered');
    }

    const isIE11 =!!window.MSInputMethodContext && !!document.documentMode;
    const stickyHeight = isIE11 ? 0 : document.querySelector('.Locator-searchWrapper').offsetHeight;

    const targetEl = document.getElementById(id);

    if (document.querySelector('html').classList.contains('chaz')) {
      function isScrolledIntoView(elem) {
        const elBottom = $(elem).position().top + elem.offsetHeight;
        return (elBottom <= (window.scrollY + window.innerHeight)) && ($(elem).position().top >= (window.scrollY + stickyHeight));
      }

      if (!isScrolledIntoView(targetEl)) {
        $('html ,body').animate({
          scrollTop: $(targetEl).offset().top - document.querySelector('header').offsetHeight - stickyHeight,
        }, {duration: 600, queue: false});
      }
    } else if (document.querySelector('html').classList.contains('ace')) {
      const container = document.querySelector('.Locator-content');
      function isScrolledIntoView(elem) {
        const elBottom = $(elem).position().top + elem.offsetHeight;
        return (elBottom <= container.offsetHeight) && ($(elem).position().top >= stickyHeight);
      }

      if (!isScrolledIntoView(targetEl)) {
        $('.Locator-content').animate({
            scrollTop: container.scrollTop + $(targetEl).offset().top - document.querySelector('header').offsetHeight - stickyHeight,
        }, {duration: 600, queue: false});
      }
    }
  });

  document.addEventListener(CardClickEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    if (!id) { return; }
    const targetEl = document.getElementById(id);
    let selector = `.js-location-result.is-selected`;
    let toRemove = document.querySelectorAll(selector);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-selected');
    }
    targetEl.classList.add('is-selected');
  });

  document.addEventListener(PinHoverEvent.eventTypeName, function(e) {
    let id = e.detail.yextId;
    const targetEl = document.getElementById(id);
    if (e.detail.active) {
      targetEl.classList.add('is-hovered');
    }
    let selector = `.js-location-result.is-hovered`;
    if (e.detail.active) {
      selector += `:not(#${id})`;
    }
    let toRemove = document.querySelectorAll(selector);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-hovered');
    }
  });
}

export const MapSetup = () => {
  registerResultHandlers();
  registerDocumentHandlers();
}
